import React from 'react';
import { Provider } from 'react-redux';
import { betslipStore } from './store/store';

import {
    initBetslip,
} from '~Betslip/interface/interactions';

import BetslipContainer from './BetslipContainer';

initBetslip();

const Betslip = () => {
    return (
        <Provider store={betslipStore}>
            <BetslipContainer />
        </Provider>
    );
};

export default Betslip;
